var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
var Label = function (_a) {
    var text = _a.text, _b = _a.fontSize, fontSize = _b === void 0 ? 20 : _b, _c = _a.offsetTop, offsetTop = _c === void 0 ? 8 : _c, className = _a.className, _d = _a.flow, flow = _d === void 0 ? false : _d;
    var style = useMemo(function () { return (__assign(__assign({}, (flow
        ? {
            // In-flow: a column-flow parent stacks this below the widget and
            // its height grows the parent (and thus the group box around it).
            position: 'relative',
            textAlign: 'center',
        }
        : {
            // Absolute: stack directly under the widget (the wrapping element
            // has 100% width matching the widget's bounding box) and center.
            position: 'absolute',
            top: "calc(100% + ".concat(offsetTop, "px)"),
            left: '50%',
            transform: 'translateX(-50%)',
        })), { fontSize: fontSize, lineHeight: 1.2, color: '#222', whiteSpace: 'nowrap', 
        // Read-only, hands-off: no interaction at all. Locks against move +
        // delete are implicit since the user can't even select this element.
        userSelect: 'none', WebkitUserSelect: 'none', pointerEvents: 'none', 
        // Stay on a high z-band relative to the widget body so the text isn't
        // covered by widget shadows or overlays.
        zIndex: 1 })); }, [fontSize, offsetTop, flow]);
    if (typeof text !== 'string' || !text.trim())
        return null;
    return (_jsx("div", { className: className ? "widgetLabel ".concat(className) : 'widgetLabel', style: style, "aria-hidden": "true", children: text }));
};
export default Label;
